import { render, staticRenderFns } from "./EditReward.vue?vue&type=template&id=cf0e5628&scoped=true"
import script from "./EditReward.vue?vue&type=script&lang=js"
export * from "./EditReward.vue?vue&type=script&lang=js"
import style0 from "./EditReward.vue?vue&type=style&index=0&id=cf0e5628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0e5628",
  null
  
)

export default component.exports